namespace _Ext {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class GridItemPickerDialog extends Serenity.TemplatedDialog<GridItemPickerEditorOptions> {
        getTemplate() {
            return `<div id="~_RowSelectionCheckGrid" 
                class="RowSelectionCheckGrid ${this.options.multiple == true ? 'multi-select' : 'single-select'}" 
                style = "margin: 15px 15px 0 15px;" >
            </div>
<div id ="~Preivew"></div>`
            
        }

        checkGrid: GridBase<any, GridItemPickerEditorOptions>;
        get selectedItems() {
            return this.checkGrid.selectedItems.filter(function (element) {
                return element !== undefined;
            });
        };
        height: number = 500;
        width: number;

        constructor(options: GridItemPickerEditorOptions) {
            super(options);

            var gridType = options.gridType;
            var title = options.title;
            this.height = options.height == null ? 500 : options.height;
            this.width = options.Width == null ? 920 : options.Width;
            if (!Q.isEmptyOrNull(options.Width))
                this.element.width = options.Width;


            
                //(this.checkGrid.view as any).onDataLoaded.subscribe(() => {
                //    this.checkGrid.slickGrid.setSelectedRows([0]);
                //});

            document.onkeydown = (ev: KeyboardEvent): any => {
                if (this.options.multiple == false) {
                    if (ev.keyCode === 13) {
                        if (this.selectedItems != undefined) {
                            this.onSuccess(this.selectedItems);
                            this.dialogClose();
                        }
                    }
                }
            }



            if (!gridType.prototype)
                gridType = Q.getTypeFullName(options.gridType);

            try {
                this.checkGrid = new gridType(this.byId("RowSelectionCheckGrid"), options);
                var opt = this.checkGrid.getGrid().getOptions();
                opt.enableTextSelectionOnCells = false;

                this.checkGrid.getGrid().setOptions(opt);

                if (options.preSelectedKeys)
                    this.checkGrid.selectedKeys = options.preSelectedKeys;

                this.dialogTitle = title;// q.text('Controls.Select', "Select") + " - " + this.checkGrid.getTitle();
                //this.checkGrid.setTitle(null);
                this.checkGrid.element.height(this.height - 100);

                this.checkGrid.pickerDialog = this;
            } catch (ex) {
                console.warn('Could not intialize ' + options.gridType);
            }
        }

        onSuccess = (selectedItems) => { }

        checkedItems() {
            var data = this.checkGrid.selectedItems;

            data = data.filter(function (element) {
                return element !== undefined;
            });
        }

        getDialogOptions() {
            let opt = super.getDialogOptions();
            opt.buttons = [{
                text: Q.text("Dialogs.OkButton"),
                click: () => {
                    var selectedItems = this.checkGrid.selectedItems.filter(function (element) {
                        return element !== undefined;
                    });
                    if (!selectedItems.length) {
                        Q.notifyWarning("Please select some items!");
                        return
                    }
                    this.onSuccess(selectedItems);
                    this.dialogClose();
                }
            }, {
                text: Q.text("Dialogs.CancelButton"),
                click: () => {
                    this.dialogClose()
                }
            }];

            opt.height = this.height;
            opt.width = this.width;

            return opt
        }

    }

}